// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 15) return "static/js/aa390445e210cfd33ed8.bundle.js";
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"29":"ada830c68aadbc4fed40","153":"a065465c5546ae2b696e","154":"6ea1021c4cf131cf38a1"}[chunkId] + ".chunk.js";
};